/* Optional additions only. Keep Dawn's native cart, checkout and line properties intact. */
(()=>{
  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-oc-variant]');if(!select)return;e.stopPropagation();
    const card=select.closest('[data-oc-complement]');
    const option=select.selectedOptions[0];if(option.dataset.price)card.querySelector('[data-oc-price]').textContent=option.dataset.price;
    if(option.dataset.img){const img=card.querySelector('img');if(img){img.removeAttribute('srcset');img.src=option.dataset.img;}if(option.dataset.href)card.querySelectorAll('a[href]').forEach(a=>{a.href=option.dataset.href;});}
    card.querySelector('[data-oc-status]').textContent='';
  },true);
  document.addEventListener('click',async e=>{
    const button=e.target.closest('[data-oc-add]');if(!button)return;
    const card=button.closest('[data-oc-complement]'),select=card.querySelector('[data-oc-variant]'),status=card.querySelector('[data-oc-status]');
    if(button.disabled)return;
    if(!select.value){status.textContent='Choisis d’abord ta taille.';select.focus();if(select.showPicker){try{select.showPicker();}catch(_){}}return;}
    button.disabled=true;select.disabled=true;status.textContent='Ajout en cours…';
    const root=window.Shopify?.routes?.root||'/';
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||'Cet article ne peut pas être ajouté. Réessaie.');
      if(button.getAttribute('role')==='switch')button.setAttribute('aria-checked','true');
      const drawer=document.querySelector('cart-drawer');
      if(await syncGift(true))return;
      if(drawer&&typeof drawer.renderContents==='function'&&data.sections?.['cart-drawer']){drawer.classList.remove('is-empty');drawer.setActiveElement(document.getElementById('cart-icon-bubble')||button);drawer.renderContents(data);}
      else location.assign(root+'cart');
    }catch(error){if(button.getAttribute('role')==='switch')button.setAttribute('aria-checked','false');status.textContent=error.message||'Ajout impossible pour le moment.';button.disabled=false;select.disabled=false;}
  });

  /* 21/10 : carte cadeau 10 € offerte (article à 0 €) ajoutée dès 100 € après remises, retirée en dessous.
     La variante et le seuil viennent de <cart-drawer data-gift-variant data-gift-threshold>. */
  const giftCfg=()=>{const d=document.querySelector('cart-drawer');return d&&d.dataset.giftVariant?{id:Number(d.dataset.giftVariant),min:Number(d.dataset.giftThreshold||10000)}:null;};
  const refreshDrawer=async()=>{
    const r=await fetch(location.pathname+'?sections=cart-drawer,cart-icon-bubble');if(!r.ok)return;const s=await r.json();
    const parse=h=>new DOMParser().parseFromString(h,'text/html');
    const d=parse(s['cart-drawer']);const next=d.querySelector('.drawer__inner'),cur=document.querySelector('cart-drawer .drawer__inner');
    if(next&&cur)cur.innerHTML=next.innerHTML;
    const drawer=document.querySelector('cart-drawer');if(drawer)drawer.classList.toggle('is-empty',!!d.querySelector('cart-drawer.is-empty'));
    const b=parse(s['cart-icon-bubble']).querySelector('.shopify-section'),bubble=document.getElementById('cart-icon-bubble');if(b&&bubble)bubble.innerHTML=b.innerHTML;
  };
  let giftBusy=false;
  const syncGift=async(render=true)=>{
    const cfg=giftCfg();if(!cfg||giftBusy)return false;giftBusy=true;
    try{
      const cart=await (await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json();
      const lines=cart.items.filter(i=>i.variant_id===cfg.id);const giftQty=lines.reduce((a,i)=>a+i.quantity,0);
      const total=cart.total_price-lines.reduce((a,i)=>a+i.final_line_price,0);
      const others=cart.items.length-lines.length;
      let body=null;
      if(total>=cfg.min&&others>0&&giftQty!==1)body=giftQty===0?{url:'/cart/add.js',data:{items:[{id:cfg.id,quantity:1}]}}:{url:'/cart/change.js',data:{id:lines[0].key,quantity:1}};
      else if((total<cfg.min||others===0)&&giftQty>0)body={url:'/cart/change.js',data:{id:lines[0].key,quantity:0}};
      if(!body){
        if(giftQty>0&&render&&!window.__ocBubbleFixed){window.__ocBubbleFixed=true;const r=await fetch(location.pathname+'?sections=cart-icon-bubble');if(r.ok){const s=await r.json();const b=new DOMParser().parseFromString(s['cart-icon-bubble'],'text/html').querySelector('.shopify-section'),bubble=document.getElementById('cart-icon-bubble');if(b&&bubble)bubble.innerHTML=b.innerHTML;}}
        return false;
      }
      await fetch(body.url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body.data)});
      if(render)await refreshDrawer();
      return true;
    }catch(e){return false;}finally{giftBusy=false;}
  };
  window.ocSyncGift=syncGift;
  const bootGift=()=>{
    try{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{setTimeout(()=>syncGift(true),60);});}catch(e){}
    syncGift(true);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootGift);else setTimeout(bootGift,0);

  /* Carrousel des suggestions du panier : défilement continu lent, pause au survol / toucher / focus,
     glissable au doigt, aucun mouvement si prefers-reduced-motion. Les cartes sont dupliquées une fois
     (clones aria-hidden, hors tabulation) pour boucler sans saut. */
  if(!customElements.get('oc-carousel')){
    customElements.define('oc-carousel',class extends HTMLElement{
      connectedCallback(){
        this.track=this.querySelector('[data-oc-track]');
        if(!this.track||this.track.children.length<2)return;
        this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused=false;this.hover=false;this.focusIn=false;this.resumeAt=0;this.pos=0;
        if(!this.reduced.matches)this.cloneCards();
        const hold=(ms)=>{this.resumeAt=performance.now()+ms;};
        this.addEventListener('mouseenter',()=>{this.hover=true;});
        this.addEventListener('mouseleave',()=>{this.hover=false;hold(600);});
        this.addEventListener('pointerdown',()=>hold(4000));
        this.addEventListener('touchstart',()=>hold(4000),{passive:true});
        this.addEventListener('wheel',()=>hold(3000),{passive:true});
        this.addEventListener('focusin',()=>{this.focusIn=true;});
        this.addEventListener('focusout',()=>{this.focusIn=this.contains(document.activeElement)&&document.activeElement!==document.body;hold(2500);});
        this.track.addEventListener('scroll',()=>{if(!this.ticking)this.wrap();},{passive:true});
        this.onVisibility=()=>hold(400);document.addEventListener('visibilitychange',this.onVisibility);
        this.last=performance.now();this.frame=requestAnimationFrame(t=>this.step(t));
      }
      disconnectedCallback(){cancelAnimationFrame(this.frame);document.removeEventListener('visibilitychange',this.onVisibility);}
      cloneCards(){
        [...this.track.children].forEach(card=>{
          const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.dataset.ocClone='';
          clone.querySelectorAll('a,button,select,input').forEach(el=>el.setAttribute('tabindex','-1'));
          clone.querySelectorAll('[role=status]').forEach(el=>el.removeAttribute('role'));
          this.track.appendChild(clone);
        });
      }
      loopWidth(){const first=this.track.querySelector('[data-oc-clone]');return first?first.offsetLeft-this.track.firstElementChild.offsetLeft:0;}
      wrap(){const w=this.loopWidth();if(w>0&&this.track.scrollLeft>=w){this.track.scrollLeft-=w;this.pos=this.track.scrollLeft;}}
      step(now){
        const dt=Math.min(now-this.last,64);this.last=now;
        const busy=this.reduced.matches||this.hover||this.focusIn||now<this.resumeAt||document.hidden||this.track.querySelector('select:disabled')||!this.offsetParent;
        if(busy){this.pos=this.track.scrollLeft;}
        else{
          this.pos+=dt*0.025;this.ticking=true;this.track.scrollLeft=this.pos;this.wrap();this.ticking=false;
        }
        this.frame=requestAnimationFrame(t=>this.step(t));
      }
    });
  }
})();
